export default __webpack_public_path__ + "static/media/nav-background.a24dbf87.svg";